const documentUINamesConstant = (userData = {}) => ({

  // sales
  // sales order
  salesOrderUIName: (userData?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.ui_name)?.trim()?.toProperCase() || 'Sales Order',
  salesOrderShortUIName: (userData?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.short_ui_name)?.trim()?.toProperCase() || 'SO',

  // amc sales order
  amcSalesOrderUIName: (userData?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.settings?.ui_name)?.trim()?.toProperCase() || 'Sample Order',
  amcSalesOrderShortUIName: (userData?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.settings?.short_ui_name)?.trim()?.toProperCase() || 'Sample Order',
  amcSalesOrderUnderscoreName: (userData?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.settings?.ui_name)?.trim()?.replaceAll(' ','_').toUpperCase() || 'SAMPLE_ORDER',
  amcSalesOrderLineUnderscoreName: (userData?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.settings?.ui_name)?.trim()?.replaceAll(' ','_').toUpperCase() + '_LINE' || 'SAMPLE_ORDER_LINE',


  // estimate
  estimateUIName: (userData?.tenant_info?.sales_config?.sub_modules?.sales_estimate?.settings?.ui_name)?.trim()?.toProperCase() || 'Estimate',
  estimateShortUIName: (userData?.tenant_info?.sales_config?.sub_modules?.sales_estimate?.settings?.short_ui_name)?.trim()?.toProperCase() || 'Estimate',
});

export default documentUINamesConstant;
